import { Injectable } from '@angular/core';
import { EventRegisterResponse, PublicEventDetails } from '@features/public-event/utils/models/public-event.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PublicEventService extends HttpHandler {
  getEventDetails(hash: string, userId?: number): Observable<HttpResponse<PublicEventDetails>> {
    const url: string = environment.apiUrls.events.publicDetails;
    return this.post<HttpResponse<PublicEventDetails>>(url, { hash, ...(userId && { user_id: userId }) });
  }

  recordViewEvent(eventId: number): Observable<HttpResponse<number>> {
    const url: string = environment.apiUrls.events.recordView;
    return this.post<HttpResponse<number>>(url, { id: eventId });
  }

  registerForEvent(eventId: number): Observable<HttpResponse<EventRegisterResponse>> {
    const url: string = environment.apiUrls.events.register;
    return this.post<HttpResponse<EventRegisterResponse>>(url, { id: eventId });
  }
}
